// "runDate" : "2024-11-21",
export const expectedLeadsByCategoryGroupIdMap = {
  10: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 16,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 34,
      },
      100: {
        costPerLead: 16,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      450: {
        costPerLead: 16,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      650: {
        costPerLead: 16,
        lowLeadsEstimate: 33,
        highLeadsEstimate: 55,
      },
      250: {
        costPerLead: 16,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 21,
      },
      50: {
        costPerLead: 16,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      750: {
        costPerLead: 16,
        lowLeadsEstimate: 38,
        highLeadsEstimate: 63,
      },
      350: {
        costPerLead: 16,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      500: {
        costPerLead: 16,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 42,
      },
      850: {
        costPerLead: 16,
        lowLeadsEstimate: 43,
        highLeadsEstimate: 72,
      },
      900: {
        costPerLead: 16,
        lowLeadsEstimate: 46,
        highLeadsEstimate: 76,
      },
      550: {
        costPerLead: 16,
        lowLeadsEstimate: 28,
        highLeadsEstimate: 47,
      },
      300: {
        costPerLead: 16,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      950: {
        costPerLead: 16,
        lowLeadsEstimate: 48,
        highLeadsEstimate: 80,
      },
      600: {
        costPerLead: 16,
        lowLeadsEstimate: 30,
        highLeadsEstimate: 51,
      },
      150: {
        costPerLead: 16,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      800: {
        costPerLead: 16,
        lowLeadsEstimate: 41,
        highLeadsEstimate: 68,
      },
      700: {
        costPerLead: 16,
        lowLeadsEstimate: 36,
        highLeadsEstimate: 59,
      },
      1000: {
        costPerLead: 16,
        lowLeadsEstimate: 51,
        highLeadsEstimate: 85,
      },
      200: {
        costPerLead: 16,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
    },
  },
  12: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 16,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 34,
      },
      100: {
        costPerLead: 16,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      450: {
        costPerLead: 16,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      650: {
        costPerLead: 16,
        lowLeadsEstimate: 33,
        highLeadsEstimate: 55,
      },
      250: {
        costPerLead: 16,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 21,
      },
      50: {
        costPerLead: 16,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      750: {
        costPerLead: 16,
        lowLeadsEstimate: 38,
        highLeadsEstimate: 63,
      },
      350: {
        costPerLead: 16,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      500: {
        costPerLead: 16,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 42,
      },
      850: {
        costPerLead: 16,
        lowLeadsEstimate: 43,
        highLeadsEstimate: 72,
      },
      900: {
        costPerLead: 16,
        lowLeadsEstimate: 46,
        highLeadsEstimate: 76,
      },
      550: {
        costPerLead: 16,
        lowLeadsEstimate: 28,
        highLeadsEstimate: 47,
      },
      300: {
        costPerLead: 16,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      950: {
        costPerLead: 16,
        lowLeadsEstimate: 48,
        highLeadsEstimate: 80,
      },
      600: {
        costPerLead: 16,
        lowLeadsEstimate: 30,
        highLeadsEstimate: 51,
      },
      150: {
        costPerLead: 16,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      800: {
        costPerLead: 16,
        lowLeadsEstimate: 41,
        highLeadsEstimate: 68,
      },
      700: {
        costPerLead: 16,
        lowLeadsEstimate: 36,
        highLeadsEstimate: 59,
      },
      1000: {
        costPerLead: 16,
        lowLeadsEstimate: 51,
        highLeadsEstimate: 85,
      },
      200: {
        costPerLead: 16,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
    },
  },
  14: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 16,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 34,
      },
      100: {
        costPerLead: 16,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      450: {
        costPerLead: 16,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      650: {
        costPerLead: 16,
        lowLeadsEstimate: 33,
        highLeadsEstimate: 55,
      },
      250: {
        costPerLead: 16,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 21,
      },
      50: {
        costPerLead: 16,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      750: {
        costPerLead: 16,
        lowLeadsEstimate: 38,
        highLeadsEstimate: 63,
      },
      350: {
        costPerLead: 16,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      500: {
        costPerLead: 16,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 42,
      },
      850: {
        costPerLead: 16,
        lowLeadsEstimate: 43,
        highLeadsEstimate: 72,
      },
      900: {
        costPerLead: 16,
        lowLeadsEstimate: 46,
        highLeadsEstimate: 76,
      },
      550: {
        costPerLead: 16,
        lowLeadsEstimate: 28,
        highLeadsEstimate: 47,
      },
      300: {
        costPerLead: 16,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      950: {
        costPerLead: 16,
        lowLeadsEstimate: 48,
        highLeadsEstimate: 80,
      },
      600: {
        costPerLead: 16,
        lowLeadsEstimate: 30,
        highLeadsEstimate: 51,
      },
      150: {
        costPerLead: 16,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      800: {
        costPerLead: 16,
        lowLeadsEstimate: 41,
        highLeadsEstimate: 68,
      },
      700: {
        costPerLead: 16,
        lowLeadsEstimate: 36,
        highLeadsEstimate: 59,
      },
      1000: {
        costPerLead: 16,
        lowLeadsEstimate: 51,
        highLeadsEstimate: 85,
      },
      200: {
        costPerLead: 16,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
    },
  },
  16: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 19,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 28,
      },
      100: {
        costPerLead: 19,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      450: {
        costPerLead: 19,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 31,
      },
      650: {
        costPerLead: 19,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 45,
      },
      250: {
        costPerLead: 19,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      50: {
        costPerLead: 19,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      750: {
        costPerLead: 19,
        lowLeadsEstimate: 31,
        highLeadsEstimate: 52,
      },
      350: {
        costPerLead: 19,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 24,
      },
      500: {
        costPerLead: 19,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 35,
      },
      850: {
        costPerLead: 19,
        lowLeadsEstimate: 35,
        highLeadsEstimate: 59,
      },
      900: {
        costPerLead: 19,
        lowLeadsEstimate: 37,
        highLeadsEstimate: 62,
      },
      550: {
        costPerLead: 19,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      300: {
        costPerLead: 19,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 21,
      },
      950: {
        costPerLead: 19,
        lowLeadsEstimate: 39,
        highLeadsEstimate: 66,
      },
      600: {
        costPerLead: 19,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 41,
      },
      150: {
        costPerLead: 19,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      800: {
        costPerLead: 19,
        lowLeadsEstimate: 33,
        highLeadsEstimate: 55,
      },
      700: {
        costPerLead: 19,
        lowLeadsEstimate: 29,
        highLeadsEstimate: 48,
      },
      1000: {
        costPerLead: 19,
        lowLeadsEstimate: 41,
        highLeadsEstimate: 69,
      },
      200: {
        costPerLead: 19,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
    },
  },
  18: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 43,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      100: {
        costPerLead: 43,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      450: {
        costPerLead: 43,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      650: {
        costPerLead: 43,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      250: {
        costPerLead: 43,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      50: {
        costPerLead: 43,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 43,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      350: {
        costPerLead: 43,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 11,
      },
      500: {
        costPerLead: 43,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      850: {
        costPerLead: 43,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 26,
      },
      900: {
        costPerLead: 43,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 28,
      },
      550: {
        costPerLead: 43,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      300: {
        costPerLead: 43,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 9,
      },
      950: {
        costPerLead: 43,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 29,
      },
      600: {
        costPerLead: 43,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      150: {
        costPerLead: 43,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      800: {
        costPerLead: 43,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      700: {
        costPerLead: 43,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      1000: {
        costPerLead: 43,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 31,
      },
      200: {
        costPerLead: 43,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
    },
  },
  2: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 21,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      100: {
        costPerLead: 21,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      450: {
        costPerLead: 21,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 29,
      },
      650: {
        costPerLead: 21,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 41,
      },
      250: {
        costPerLead: 21,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      50: {
        costPerLead: 21,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      750: {
        costPerLead: 21,
        lowLeadsEstimate: 29,
        highLeadsEstimate: 48,
      },
      350: {
        costPerLead: 21,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      500: {
        costPerLead: 21,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      850: {
        costPerLead: 21,
        lowLeadsEstimate: 32,
        highLeadsEstimate: 54,
      },
      900: {
        costPerLead: 21,
        lowLeadsEstimate: 34,
        highLeadsEstimate: 57,
      },
      550: {
        costPerLead: 21,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 35,
      },
      300: {
        costPerLead: 21,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      950: {
        costPerLead: 21,
        lowLeadsEstimate: 36,
        highLeadsEstimate: 60,
      },
      600: {
        costPerLead: 21,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      150: {
        costPerLead: 21,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      800: {
        costPerLead: 21,
        lowLeadsEstimate: 30,
        highLeadsEstimate: 51,
      },
      700: {
        costPerLead: 21,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 44,
      },
      1000: {
        costPerLead: 21,
        lowLeadsEstimate: 38,
        highLeadsEstimate: 64,
      },
      200: {
        costPerLead: 21,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
    },
  },
  20: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 20,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      100: {
        costPerLead: 20,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      450: {
        costPerLead: 20,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      650: {
        costPerLead: 20,
        lowLeadsEstimate: 26,
        highLeadsEstimate: 44,
      },
      250: {
        costPerLead: 20,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      50: {
        costPerLead: 20,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      750: {
        costPerLead: 20,
        lowLeadsEstimate: 30,
        highLeadsEstimate: 51,
      },
      350: {
        costPerLead: 20,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 24,
      },
      500: {
        costPerLead: 20,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 34,
      },
      850: {
        costPerLead: 20,
        lowLeadsEstimate: 34,
        highLeadsEstimate: 57,
      },
      900: {
        costPerLead: 20,
        lowLeadsEstimate: 36,
        highLeadsEstimate: 61,
      },
      550: {
        costPerLead: 20,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 37,
      },
      300: {
        costPerLead: 20,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      950: {
        costPerLead: 20,
        lowLeadsEstimate: 38,
        highLeadsEstimate: 64,
      },
      600: {
        costPerLead: 20,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 40,
      },
      150: {
        costPerLead: 20,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      800: {
        costPerLead: 20,
        lowLeadsEstimate: 32,
        highLeadsEstimate: 54,
      },
      700: {
        costPerLead: 20,
        lowLeadsEstimate: 28,
        highLeadsEstimate: 47,
      },
      1000: {
        costPerLead: 20,
        lowLeadsEstimate: 40,
        highLeadsEstimate: 67,
      },
      200: {
        costPerLead: 20,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
    },
  },
  22: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 15,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 36,
      },
      100: {
        costPerLead: 15,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
      450: {
        costPerLead: 15,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 41,
      },
      650: {
        costPerLead: 15,
        lowLeadsEstimate: 35,
        highLeadsEstimate: 59,
      },
      250: {
        costPerLead: 15,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      50: {
        costPerLead: 15,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      750: {
        costPerLead: 15,
        lowLeadsEstimate: 41,
        highLeadsEstimate: 68,
      },
      350: {
        costPerLead: 15,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      500: {
        costPerLead: 15,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 45,
      },
      850: {
        costPerLead: 15,
        lowLeadsEstimate: 46,
        highLeadsEstimate: 77,
      },
      900: {
        costPerLead: 15,
        lowLeadsEstimate: 49,
        highLeadsEstimate: 82,
      },
      550: {
        costPerLead: 15,
        lowLeadsEstimate: 30,
        highLeadsEstimate: 50,
      },
      300: {
        costPerLead: 15,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      950: {
        costPerLead: 15,
        lowLeadsEstimate: 52,
        highLeadsEstimate: 86,
      },
      600: {
        costPerLead: 15,
        lowLeadsEstimate: 33,
        highLeadsEstimate: 54,
      },
      150: {
        costPerLead: 15,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      800: {
        costPerLead: 15,
        lowLeadsEstimate: 44,
        highLeadsEstimate: 73,
      },
      700: {
        costPerLead: 15,
        lowLeadsEstimate: 38,
        highLeadsEstimate: 64,
      },
      1000: {
        costPerLead: 15,
        lowLeadsEstimate: 54,
        highLeadsEstimate: 91,
      },
      200: {
        costPerLead: 15,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
    },
  },
  24: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 17,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      100: {
        costPerLead: 17,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      450: {
        costPerLead: 17,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 36,
      },
      650: {
        costPerLead: 17,
        lowLeadsEstimate: 31,
        highLeadsEstimate: 52,
      },
      250: {
        costPerLead: 17,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      50: {
        costPerLead: 17,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 4,
      },
      750: {
        costPerLead: 17,
        lowLeadsEstimate: 36,
        highLeadsEstimate: 60,
      },
      350: {
        costPerLead: 17,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 28,
      },
      500: {
        costPerLead: 17,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 40,
      },
      850: {
        costPerLead: 17,
        lowLeadsEstimate: 40,
        highLeadsEstimate: 67,
      },
      900: {
        costPerLead: 17,
        lowLeadsEstimate: 43,
        highLeadsEstimate: 71,
      },
      550: {
        costPerLead: 17,
        lowLeadsEstimate: 26,
        highLeadsEstimate: 44,
      },
      300: {
        costPerLead: 17,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 24,
      },
      950: {
        costPerLead: 17,
        lowLeadsEstimate: 45,
        highLeadsEstimate: 75,
      },
      600: {
        costPerLead: 17,
        lowLeadsEstimate: 29,
        highLeadsEstimate: 48,
      },
      150: {
        costPerLead: 17,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      800: {
        costPerLead: 17,
        lowLeadsEstimate: 38,
        highLeadsEstimate: 63,
      },
      700: {
        costPerLead: 17,
        lowLeadsEstimate: 33,
        highLeadsEstimate: 56,
      },
      1000: {
        costPerLead: 17,
        lowLeadsEstimate: 48,
        highLeadsEstimate: 79,
      },
      200: {
        costPerLead: 17,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
    },
  },
  26: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 31,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      100: {
        costPerLead: 31,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      450: {
        costPerLead: 31,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 19,
      },
      650: {
        costPerLead: 31,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 28,
      },
      250: {
        costPerLead: 31,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 11,
      },
      50: {
        costPerLead: 31,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 31,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      350: {
        costPerLead: 31,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      500: {
        costPerLead: 31,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 21,
      },
      850: {
        costPerLead: 31,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 36,
      },
      900: {
        costPerLead: 31,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      550: {
        costPerLead: 31,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      300: {
        costPerLead: 31,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      950: {
        costPerLead: 31,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 41,
      },
      600: {
        costPerLead: 31,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 26,
      },
      150: {
        costPerLead: 31,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      800: {
        costPerLead: 31,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 34,
      },
      700: {
        costPerLead: 31,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      1000: {
        costPerLead: 31,
        lowLeadsEstimate: 26,
        highLeadsEstimate: 43,
      },
      200: {
        costPerLead: 31,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
    },
  },
  28: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 16,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 33,
      },
      100: {
        costPerLead: 16,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      450: {
        costPerLead: 16,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 37,
      },
      650: {
        costPerLead: 16,
        lowLeadsEstimate: 32,
        highLeadsEstimate: 54,
      },
      250: {
        costPerLead: 16,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 21,
      },
      50: {
        costPerLead: 16,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 4,
      },
      750: {
        costPerLead: 16,
        lowLeadsEstimate: 37,
        highLeadsEstimate: 62,
      },
      350: {
        costPerLead: 16,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 29,
      },
      500: {
        costPerLead: 16,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 42,
      },
      850: {
        costPerLead: 16,
        lowLeadsEstimate: 42,
        highLeadsEstimate: 71,
      },
      900: {
        costPerLead: 16,
        lowLeadsEstimate: 45,
        highLeadsEstimate: 75,
      },
      550: {
        costPerLead: 16,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 46,
      },
      300: {
        costPerLead: 16,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      950: {
        costPerLead: 16,
        lowLeadsEstimate: 47,
        highLeadsEstimate: 79,
      },
      600: {
        costPerLead: 16,
        lowLeadsEstimate: 30,
        highLeadsEstimate: 50,
      },
      150: {
        costPerLead: 16,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      800: {
        costPerLead: 16,
        lowLeadsEstimate: 40,
        highLeadsEstimate: 67,
      },
      700: {
        costPerLead: 16,
        lowLeadsEstimate: 35,
        highLeadsEstimate: 58,
      },
      1000: {
        costPerLead: 16,
        lowLeadsEstimate: 50,
        highLeadsEstimate: 83,
      },
      200: {
        costPerLead: 16,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
    },
  },
  30: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 39,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      100: {
        costPerLead: 39,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      450: {
        costPerLead: 39,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      650: {
        costPerLead: 39,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      250: {
        costPerLead: 39,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      50: {
        costPerLead: 39,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 39,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      350: {
        costPerLead: 39,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      500: {
        costPerLead: 39,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      850: {
        costPerLead: 39,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 29,
      },
      900: {
        costPerLead: 39,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 31,
      },
      550: {
        costPerLead: 39,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      300: {
        costPerLead: 39,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      950: {
        costPerLead: 39,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      600: {
        costPerLead: 39,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      150: {
        costPerLead: 39,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      800: {
        costPerLead: 39,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      700: {
        costPerLead: 39,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 24,
      },
      1000: {
        costPerLead: 39,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 34,
      },
      200: {
        costPerLead: 39,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
    },
  },
  32: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 31,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      100: {
        costPerLead: 31,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      450: {
        costPerLead: 31,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 19,
      },
      650: {
        costPerLead: 31,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 28,
      },
      250: {
        costPerLead: 31,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 11,
      },
      50: {
        costPerLead: 31,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 31,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      350: {
        costPerLead: 31,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      500: {
        costPerLead: 31,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 21,
      },
      850: {
        costPerLead: 31,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 36,
      },
      900: {
        costPerLead: 31,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 39,
      },
      550: {
        costPerLead: 31,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 24,
      },
      300: {
        costPerLead: 31,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      950: {
        costPerLead: 31,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 41,
      },
      600: {
        costPerLead: 31,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 26,
      },
      150: {
        costPerLead: 31,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      800: {
        costPerLead: 31,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 34,
      },
      700: {
        costPerLead: 31,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      1000: {
        costPerLead: 31,
        lowLeadsEstimate: 26,
        highLeadsEstimate: 43,
      },
      200: {
        costPerLead: 31,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
    },
  },
  34: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 55,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      100: {
        costPerLead: 55,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      450: {
        costPerLead: 55,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 11,
      },
      650: {
        costPerLead: 55,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      250: {
        costPerLead: 55,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      50: {
        costPerLead: 55,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 1,
      },
      750: {
        costPerLead: 55,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      350: {
        costPerLead: 55,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
      500: {
        costPerLead: 55,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      850: {
        costPerLead: 55,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 21,
      },
      900: {
        costPerLead: 55,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      550: {
        costPerLead: 55,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      300: {
        costPerLead: 55,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      950: {
        costPerLead: 55,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      600: {
        costPerLead: 55,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      150: {
        costPerLead: 55,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 4,
      },
      800: {
        costPerLead: 55,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      700: {
        costPerLead: 55,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      1000: {
        costPerLead: 55,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 24,
      },
      200: {
        costPerLead: 55,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
    },
  },
  36: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 27,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      100: {
        costPerLead: 27,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      450: {
        costPerLead: 27,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      650: {
        costPerLead: 27,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      250: {
        costPerLead: 27,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      50: {
        costPerLead: 27,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 27,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 37,
      },
      350: {
        costPerLead: 27,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      500: {
        costPerLead: 27,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      850: {
        costPerLead: 27,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 42,
      },
      900: {
        costPerLead: 27,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 44,
      },
      550: {
        costPerLead: 27,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      300: {
        costPerLead: 27,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      950: {
        costPerLead: 27,
        lowLeadsEstimate: 28,
        highLeadsEstimate: 47,
      },
      600: {
        costPerLead: 27,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      150: {
        costPerLead: 27,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      800: {
        costPerLead: 27,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 39,
      },
      700: {
        costPerLead: 27,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 34,
      },
      1000: {
        costPerLead: 27,
        lowLeadsEstimate: 30,
        highLeadsEstimate: 49,
      },
      200: {
        costPerLead: 27,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
    },
  },
  38: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 21,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      100: {
        costPerLead: 21,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      450: {
        costPerLead: 21,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 29,
      },
      650: {
        costPerLead: 21,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 41,
      },
      250: {
        costPerLead: 21,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      50: {
        costPerLead: 21,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      750: {
        costPerLead: 21,
        lowLeadsEstimate: 29,
        highLeadsEstimate: 48,
      },
      350: {
        costPerLead: 21,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      500: {
        costPerLead: 21,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      850: {
        costPerLead: 21,
        lowLeadsEstimate: 32,
        highLeadsEstimate: 54,
      },
      900: {
        costPerLead: 21,
        lowLeadsEstimate: 34,
        highLeadsEstimate: 57,
      },
      550: {
        costPerLead: 21,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 35,
      },
      300: {
        costPerLead: 21,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      950: {
        costPerLead: 21,
        lowLeadsEstimate: 36,
        highLeadsEstimate: 60,
      },
      600: {
        costPerLead: 21,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      150: {
        costPerLead: 21,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      800: {
        costPerLead: 21,
        lowLeadsEstimate: 31,
        highLeadsEstimate: 51,
      },
      700: {
        costPerLead: 21,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 45,
      },
      1000: {
        costPerLead: 21,
        lowLeadsEstimate: 38,
        highLeadsEstimate: 64,
      },
      200: {
        costPerLead: 21,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
    },
  },
  4: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 11,
        lowLeadsEstimate: 28,
        highLeadsEstimate: 47,
      },
      100: {
        costPerLead: 11,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      450: {
        costPerLead: 11,
        lowLeadsEstimate: 32,
        highLeadsEstimate: 53,
      },
      650: {
        costPerLead: 11,
        lowLeadsEstimate: 46,
        highLeadsEstimate: 77,
      },
      250: {
        costPerLead: 11,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 29,
      },
      50: {
        costPerLead: 11,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      750: {
        costPerLead: 11,
        lowLeadsEstimate: 53,
        highLeadsEstimate: 88,
      },
      350: {
        costPerLead: 11,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 41,
      },
      500: {
        costPerLead: 11,
        lowLeadsEstimate: 35,
        highLeadsEstimate: 59,
      },
      850: {
        costPerLead: 11,
        lowLeadsEstimate: 60,
        highLeadsEstimate: 100,
      },
      900: {
        costPerLead: 11,
        lowLeadsEstimate: 64,
        highLeadsEstimate: 106,
      },
      550: {
        costPerLead: 11,
        lowLeadsEstimate: 39,
        highLeadsEstimate: 65,
      },
      300: {
        costPerLead: 11,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 35,
      },
      950: {
        costPerLead: 11,
        lowLeadsEstimate: 67,
        highLeadsEstimate: 112,
      },
      600: {
        costPerLead: 11,
        lowLeadsEstimate: 42,
        highLeadsEstimate: 71,
      },
      150: {
        costPerLead: 11,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      800: {
        costPerLead: 11,
        lowLeadsEstimate: 57,
        highLeadsEstimate: 94,
      },
      700: {
        costPerLead: 11,
        lowLeadsEstimate: 50,
        highLeadsEstimate: 83,
      },
      1000: {
        costPerLead: 11,
        lowLeadsEstimate: 71,
        highLeadsEstimate: 118,
      },
      200: {
        costPerLead: 11,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 24,
      },
    },
  },
  40: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 28,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 19,
      },
      100: {
        costPerLead: 28,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      450: {
        costPerLead: 28,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      650: {
        costPerLead: 28,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 31,
      },
      250: {
        costPerLead: 28,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      50: {
        costPerLead: 28,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 28,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 36,
      },
      350: {
        costPerLead: 28,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      500: {
        costPerLead: 28,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 24,
      },
      850: {
        costPerLead: 28,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 41,
      },
      900: {
        costPerLead: 28,
        lowLeadsEstimate: 26,
        highLeadsEstimate: 43,
      },
      550: {
        costPerLead: 28,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 26,
      },
      300: {
        costPerLead: 28,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 14,
      },
      950: {
        costPerLead: 28,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 46,
      },
      600: {
        costPerLead: 28,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 29,
      },
      150: {
        costPerLead: 28,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      800: {
        costPerLead: 28,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      700: {
        costPerLead: 28,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 34,
      },
      1000: {
        costPerLead: 28,
        lowLeadsEstimate: 29,
        highLeadsEstimate: 48,
      },
      200: {
        costPerLead: 28,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
    },
  },
  42: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 14,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 39,
      },
      100: {
        costPerLead: 14,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      450: {
        costPerLead: 14,
        lowLeadsEstimate: 26,
        highLeadsEstimate: 44,
      },
      650: {
        costPerLead: 14,
        lowLeadsEstimate: 38,
        highLeadsEstimate: 63,
      },
      250: {
        costPerLead: 14,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 24,
      },
      50: {
        costPerLead: 14,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      750: {
        costPerLead: 14,
        lowLeadsEstimate: 44,
        highLeadsEstimate: 73,
      },
      350: {
        costPerLead: 14,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 34,
      },
      500: {
        costPerLead: 14,
        lowLeadsEstimate: 29,
        highLeadsEstimate: 49,
      },
      850: {
        costPerLead: 14,
        lowLeadsEstimate: 50,
        highLeadsEstimate: 83,
      },
      900: {
        costPerLead: 14,
        lowLeadsEstimate: 53,
        highLeadsEstimate: 88,
      },
      550: {
        costPerLead: 14,
        lowLeadsEstimate: 32,
        highLeadsEstimate: 54,
      },
      300: {
        costPerLead: 14,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 29,
      },
      950: {
        costPerLead: 14,
        lowLeadsEstimate: 56,
        highLeadsEstimate: 93,
      },
      600: {
        costPerLead: 14,
        lowLeadsEstimate: 35,
        highLeadsEstimate: 59,
      },
      150: {
        costPerLead: 14,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      800: {
        costPerLead: 14,
        lowLeadsEstimate: 47,
        highLeadsEstimate: 78,
      },
      700: {
        costPerLead: 14,
        lowLeadsEstimate: 41,
        highLeadsEstimate: 68,
      },
      1000: {
        costPerLead: 14,
        lowLeadsEstimate: 59,
        highLeadsEstimate: 98,
      },
      200: {
        costPerLead: 14,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
    },
  },
  44: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 25,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      100: {
        costPerLead: 25,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      450: {
        costPerLead: 25,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 24,
      },
      650: {
        costPerLead: 25,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 35,
      },
      250: {
        costPerLead: 25,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      50: {
        costPerLead: 25,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      750: {
        costPerLead: 25,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 40,
      },
      350: {
        costPerLead: 25,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      500: {
        costPerLead: 25,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      850: {
        costPerLead: 25,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 46,
      },
      900: {
        costPerLead: 25,
        lowLeadsEstimate: 29,
        highLeadsEstimate: 48,
      },
      550: {
        costPerLead: 25,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      300: {
        costPerLead: 25,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      950: {
        costPerLead: 25,
        lowLeadsEstimate: 31,
        highLeadsEstimate: 51,
      },
      600: {
        costPerLead: 25,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      150: {
        costPerLead: 25,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      800: {
        costPerLead: 25,
        lowLeadsEstimate: 26,
        highLeadsEstimate: 43,
      },
      700: {
        costPerLead: 25,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      1000: {
        costPerLead: 25,
        lowLeadsEstimate: 32,
        highLeadsEstimate: 54,
      },
      200: {
        costPerLead: 25,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 11,
      },
    },
  },
  46: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 48,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 11,
      },
      100: {
        costPerLead: 48,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      450: {
        costPerLead: 48,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      650: {
        costPerLead: 48,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      250: {
        costPerLead: 48,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      50: {
        costPerLead: 48,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 1,
      },
      750: {
        costPerLead: 48,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 21,
      },
      350: {
        costPerLead: 48,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      500: {
        costPerLead: 48,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      850: {
        costPerLead: 48,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      900: {
        costPerLead: 48,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      550: {
        costPerLead: 48,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      300: {
        costPerLead: 48,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      950: {
        costPerLead: 48,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 26,
      },
      600: {
        costPerLead: 48,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      150: {
        costPerLead: 48,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 4,
      },
      800: {
        costPerLead: 48,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      700: {
        costPerLead: 48,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 19,
      },
      1000: {
        costPerLead: 48,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 28,
      },
      200: {
        costPerLead: 48,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 6,
      },
    },
  },
  48: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 20,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 26,
      },
      100: {
        costPerLead: 20,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      450: {
        costPerLead: 20,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      650: {
        costPerLead: 20,
        lowLeadsEstimate: 26,
        highLeadsEstimate: 43,
      },
      250: {
        costPerLead: 20,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      50: {
        costPerLead: 20,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      750: {
        costPerLead: 20,
        lowLeadsEstimate: 30,
        highLeadsEstimate: 49,
      },
      350: {
        costPerLead: 20,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      500: {
        costPerLead: 20,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 33,
      },
      850: {
        costPerLead: 20,
        lowLeadsEstimate: 34,
        highLeadsEstimate: 56,
      },
      900: {
        costPerLead: 20,
        lowLeadsEstimate: 36,
        highLeadsEstimate: 59,
      },
      550: {
        costPerLead: 20,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 36,
      },
      300: {
        costPerLead: 20,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      950: {
        costPerLead: 20,
        lowLeadsEstimate: 38,
        highLeadsEstimate: 63,
      },
      600: {
        costPerLead: 20,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 40,
      },
      150: {
        costPerLead: 20,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      800: {
        costPerLead: 20,
        lowLeadsEstimate: 32,
        highLeadsEstimate: 53,
      },
      700: {
        costPerLead: 20,
        lowLeadsEstimate: 28,
        highLeadsEstimate: 46,
      },
      1000: {
        costPerLead: 20,
        lowLeadsEstimate: 40,
        highLeadsEstimate: 66,
      },
      200: {
        costPerLead: 20,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
    },
  },
  50: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 45,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      100: {
        costPerLead: 45,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      450: {
        costPerLead: 45,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      650: {
        costPerLead: 45,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 19,
      },
      250: {
        costPerLead: 45,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      50: {
        costPerLead: 45,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 1,
      },
      750: {
        costPerLead: 45,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      350: {
        costPerLead: 45,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      500: {
        costPerLead: 45,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      850: {
        costPerLead: 45,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      900: {
        costPerLead: 45,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      550: {
        costPerLead: 45,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      300: {
        costPerLead: 45,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
      950: {
        costPerLead: 45,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 28,
      },
      600: {
        costPerLead: 45,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      150: {
        costPerLead: 45,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      800: {
        costPerLead: 45,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 24,
      },
      700: {
        costPerLead: 45,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 21,
      },
      1000: {
        costPerLead: 45,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      200: {
        costPerLead: 45,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
    },
  },
  52: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 27,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 19,
      },
      100: {
        costPerLead: 27,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      450: {
        costPerLead: 27,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      650: {
        costPerLead: 27,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      250: {
        costPerLead: 27,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      50: {
        costPerLead: 27,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 27,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 36,
      },
      350: {
        costPerLead: 27,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      500: {
        costPerLead: 27,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 24,
      },
      850: {
        costPerLead: 27,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 41,
      },
      900: {
        costPerLead: 27,
        lowLeadsEstimate: 26,
        highLeadsEstimate: 44,
      },
      550: {
        costPerLead: 27,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      300: {
        costPerLead: 27,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      950: {
        costPerLead: 27,
        lowLeadsEstimate: 28,
        highLeadsEstimate: 46,
      },
      600: {
        costPerLead: 27,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 29,
      },
      150: {
        costPerLead: 27,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      800: {
        costPerLead: 27,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 39,
      },
      700: {
        costPerLead: 27,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 34,
      },
      1000: {
        costPerLead: 27,
        lowLeadsEstimate: 29,
        highLeadsEstimate: 49,
      },
      200: {
        costPerLead: 27,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
    },
  },
  54: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 46,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 11,
      },
      100: {
        costPerLead: 46,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      450: {
        costPerLead: 46,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      650: {
        costPerLead: 46,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      250: {
        costPerLead: 46,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      50: {
        costPerLead: 46,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 1,
      },
      750: {
        costPerLead: 46,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      350: {
        costPerLead: 46,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      500: {
        costPerLead: 46,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 14,
      },
      850: {
        costPerLead: 46,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 24,
      },
      900: {
        costPerLead: 46,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 26,
      },
      550: {
        costPerLead: 46,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 16,
      },
      300: {
        costPerLead: 46,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
      950: {
        costPerLead: 46,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      600: {
        costPerLead: 46,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      150: {
        costPerLead: 46,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      800: {
        costPerLead: 46,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      700: {
        costPerLead: 46,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      1000: {
        costPerLead: 46,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 29,
      },
      200: {
        costPerLead: 46,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 6,
      },
    },
  },
  56: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 33,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      100: {
        costPerLead: 33,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 4,
      },
      450: {
        costPerLead: 33,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      650: {
        costPerLead: 33,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 26,
      },
      250: {
        costPerLead: 33,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      50: {
        costPerLead: 33,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 33,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      350: {
        costPerLead: 33,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      500: {
        costPerLead: 33,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      850: {
        costPerLead: 33,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 34,
      },
      900: {
        costPerLead: 33,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 36,
      },
      550: {
        costPerLead: 33,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      300: {
        costPerLead: 33,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      950: {
        costPerLead: 33,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      600: {
        costPerLead: 33,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 24,
      },
      150: {
        costPerLead: 33,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      800: {
        costPerLead: 33,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      700: {
        costPerLead: 33,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 28,
      },
      1000: {
        costPerLead: 33,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 40,
      },
      200: {
        costPerLead: 33,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
    },
  },
  58: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 32,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      100: {
        costPerLead: 32,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      450: {
        costPerLead: 32,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      650: {
        costPerLead: 32,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 28,
      },
      250: {
        costPerLead: 32,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 11,
      },
      50: {
        costPerLead: 32,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 32,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      350: {
        costPerLead: 32,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      500: {
        costPerLead: 32,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 21,
      },
      850: {
        costPerLead: 32,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 36,
      },
      900: {
        costPerLead: 32,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      550: {
        costPerLead: 32,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      300: {
        costPerLead: 32,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      950: {
        costPerLead: 32,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 40,
      },
      600: {
        costPerLead: 32,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      150: {
        costPerLead: 32,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      800: {
        costPerLead: 32,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 34,
      },
      700: {
        costPerLead: 32,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      1000: {
        costPerLead: 32,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 42,
      },
      200: {
        costPerLead: 32,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
    },
  },
  6: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 17,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      100: {
        costPerLead: 17,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      450: {
        costPerLead: 17,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 35,
      },
      650: {
        costPerLead: 17,
        lowLeadsEstimate: 31,
        highLeadsEstimate: 51,
      },
      250: {
        costPerLead: 17,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      50: {
        costPerLead: 17,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 4,
      },
      750: {
        costPerLead: 17,
        lowLeadsEstimate: 35,
        highLeadsEstimate: 59,
      },
      350: {
        costPerLead: 17,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 28,
      },
      500: {
        costPerLead: 17,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 39,
      },
      850: {
        costPerLead: 17,
        lowLeadsEstimate: 40,
        highLeadsEstimate: 67,
      },
      900: {
        costPerLead: 17,
        lowLeadsEstimate: 43,
        highLeadsEstimate: 71,
      },
      550: {
        costPerLead: 17,
        lowLeadsEstimate: 26,
        highLeadsEstimate: 43,
      },
      300: {
        costPerLead: 17,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 24,
      },
      950: {
        costPerLead: 17,
        lowLeadsEstimate: 45,
        highLeadsEstimate: 75,
      },
      600: {
        costPerLead: 17,
        lowLeadsEstimate: 28,
        highLeadsEstimate: 47,
      },
      150: {
        costPerLead: 17,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      800: {
        costPerLead: 17,
        lowLeadsEstimate: 38,
        highLeadsEstimate: 63,
      },
      700: {
        costPerLead: 17,
        lowLeadsEstimate: 33,
        highLeadsEstimate: 55,
      },
      1000: {
        costPerLead: 17,
        lowLeadsEstimate: 47,
        highLeadsEstimate: 79,
      },
      200: {
        costPerLead: 17,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 16,
      },
    },
  },
  60: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 22,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 24,
      },
      100: {
        costPerLead: 22,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      450: {
        costPerLead: 22,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      650: {
        costPerLead: 22,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 39,
      },
      250: {
        costPerLead: 22,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      50: {
        costPerLead: 22,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      750: {
        costPerLead: 22,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 44,
      },
      350: {
        costPerLead: 22,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 21,
      },
      500: {
        costPerLead: 22,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      850: {
        costPerLead: 22,
        lowLeadsEstimate: 30,
        highLeadsEstimate: 50,
      },
      900: {
        costPerLead: 22,
        lowLeadsEstimate: 32,
        highLeadsEstimate: 53,
      },
      550: {
        costPerLead: 22,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 33,
      },
      300: {
        costPerLead: 22,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      950: {
        costPerLead: 22,
        lowLeadsEstimate: 34,
        highLeadsEstimate: 56,
      },
      600: {
        costPerLead: 22,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 36,
      },
      150: {
        costPerLead: 22,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
      800: {
        costPerLead: 22,
        lowLeadsEstimate: 28,
        highLeadsEstimate: 47,
      },
      700: {
        costPerLead: 22,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 42,
      },
      1000: {
        costPerLead: 22,
        lowLeadsEstimate: 36,
        highLeadsEstimate: 59,
      },
      200: {
        costPerLead: 22,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
    },
  },
  62: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 32,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      100: {
        costPerLead: 32,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      450: {
        costPerLead: 32,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      650: {
        costPerLead: 32,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 28,
      },
      250: {
        costPerLead: 32,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 11,
      },
      50: {
        costPerLead: 32,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 32,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      350: {
        costPerLead: 32,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      500: {
        costPerLead: 32,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 21,
      },
      850: {
        costPerLead: 32,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 36,
      },
      900: {
        costPerLead: 32,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      550: {
        costPerLead: 32,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      300: {
        costPerLead: 32,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      950: {
        costPerLead: 32,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 40,
      },
      600: {
        costPerLead: 32,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      150: {
        costPerLead: 32,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      800: {
        costPerLead: 32,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 34,
      },
      700: {
        costPerLead: 32,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      1000: {
        costPerLead: 32,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 42,
      },
      200: {
        costPerLead: 32,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
    },
  },
  64: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 37,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 14,
      },
      100: {
        costPerLead: 37,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 4,
      },
      450: {
        costPerLead: 37,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      650: {
        costPerLead: 37,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      250: {
        costPerLead: 37,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
      50: {
        costPerLead: 37,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 37,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      350: {
        costPerLead: 37,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      500: {
        costPerLead: 37,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      850: {
        costPerLead: 37,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      900: {
        costPerLead: 37,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      550: {
        costPerLead: 37,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      300: {
        costPerLead: 37,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 11,
      },
      950: {
        costPerLead: 37,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 34,
      },
      600: {
        costPerLead: 37,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 21,
      },
      150: {
        costPerLead: 37,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      800: {
        costPerLead: 37,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 29,
      },
      700: {
        costPerLead: 37,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      1000: {
        costPerLead: 37,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 36,
      },
      200: {
        costPerLead: 37,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
    },
  },
  66: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 94,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 6,
      },
      100: {
        costPerLead: 94,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 1,
      },
      450: {
        costPerLead: 94,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      650: {
        costPerLead: 94,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 9,
      },
      250: {
        costPerLead: 94,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 4,
      },
      50: {
        costPerLead: 94,
        lowLeadsEstimate: 0,
        highLeadsEstimate: 1,
      },
      750: {
        costPerLead: 94,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 11,
      },
      350: {
        costPerLead: 94,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      500: {
        costPerLead: 94,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      850: {
        costPerLead: 94,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      900: {
        costPerLead: 94,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      550: {
        costPerLead: 94,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      300: {
        costPerLead: 94,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      950: {
        costPerLead: 94,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      600: {
        costPerLead: 94,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      150: {
        costPerLead: 94,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      800: {
        costPerLead: 94,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 11,
      },
      700: {
        costPerLead: 94,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      1000: {
        costPerLead: 94,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      200: {
        costPerLead: 94,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
    },
  },
  68: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 30,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      100: {
        costPerLead: 30,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      450: {
        costPerLead: 30,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      650: {
        costPerLead: 30,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 29,
      },
      250: {
        costPerLead: 30,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 11,
      },
      50: {
        costPerLead: 30,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 30,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 33,
      },
      350: {
        costPerLead: 30,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      500: {
        costPerLead: 30,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      850: {
        costPerLead: 30,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      900: {
        costPerLead: 30,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 40,
      },
      550: {
        costPerLead: 30,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 24,
      },
      300: {
        costPerLead: 30,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      950: {
        costPerLead: 30,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 42,
      },
      600: {
        costPerLead: 30,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      150: {
        costPerLead: 30,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      800: {
        costPerLead: 30,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 35,
      },
      700: {
        costPerLead: 30,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 31,
      },
      1000: {
        costPerLead: 30,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 44,
      },
      200: {
        costPerLead: 30,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
    },
  },
  70: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 24,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      100: {
        costPerLead: 24,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 6,
      },
      450: {
        costPerLead: 24,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      650: {
        costPerLead: 24,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 36,
      },
      250: {
        costPerLead: 24,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      50: {
        costPerLead: 24,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      750: {
        costPerLead: 24,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 42,
      },
      350: {
        costPerLead: 24,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 19,
      },
      500: {
        costPerLead: 24,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 28,
      },
      850: {
        costPerLead: 24,
        lowLeadsEstimate: 28,
        highLeadsEstimate: 47,
      },
      900: {
        costPerLead: 24,
        lowLeadsEstimate: 30,
        highLeadsEstimate: 50,
      },
      550: {
        costPerLead: 24,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      300: {
        costPerLead: 24,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      950: {
        costPerLead: 24,
        lowLeadsEstimate: 32,
        highLeadsEstimate: 53,
      },
      600: {
        costPerLead: 24,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 33,
      },
      150: {
        costPerLead: 24,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      800: {
        costPerLead: 24,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 44,
      },
      700: {
        costPerLead: 24,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 39,
      },
      1000: {
        costPerLead: 24,
        lowLeadsEstimate: 33,
        highLeadsEstimate: 55,
      },
      200: {
        costPerLead: 24,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 11,
      },
    },
  },
  72: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 28,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      100: {
        costPerLead: 28,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      450: {
        costPerLead: 28,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 21,
      },
      650: {
        costPerLead: 28,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 31,
      },
      250: {
        costPerLead: 28,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      50: {
        costPerLead: 28,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 28,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 35,
      },
      350: {
        costPerLead: 28,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      500: {
        costPerLead: 28,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 24,
      },
      850: {
        costPerLead: 28,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 40,
      },
      900: {
        costPerLead: 28,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 42,
      },
      550: {
        costPerLead: 28,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 26,
      },
      300: {
        costPerLead: 28,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      950: {
        costPerLead: 28,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 45,
      },
      600: {
        costPerLead: 28,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 28,
      },
      150: {
        costPerLead: 28,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      800: {
        costPerLead: 28,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      700: {
        costPerLead: 28,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 33,
      },
      1000: {
        costPerLead: 28,
        lowLeadsEstimate: 28,
        highLeadsEstimate: 47,
      },
      200: {
        costPerLead: 28,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 9,
      },
    },
  },
  74: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 44,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      100: {
        costPerLead: 44,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      450: {
        costPerLead: 44,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      650: {
        costPerLead: 44,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      250: {
        costPerLead: 44,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      50: {
        costPerLead: 44,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 44,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      350: {
        costPerLead: 44,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 11,
      },
      500: {
        costPerLead: 44,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      850: {
        costPerLead: 44,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 26,
      },
      900: {
        costPerLead: 44,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      550: {
        costPerLead: 44,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      300: {
        costPerLead: 44,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
      950: {
        costPerLead: 44,
        lowLeadsEstimate: 17,
        highLeadsEstimate: 29,
      },
      600: {
        costPerLead: 44,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      150: {
        costPerLead: 44,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      800: {
        costPerLead: 44,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 24,
      },
      700: {
        costPerLead: 44,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 21,
      },
      1000: {
        costPerLead: 44,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      200: {
        costPerLead: 44,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
    },
  },
  76: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 50,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 11,
      },
      100: {
        costPerLead: 50,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      450: {
        costPerLead: 50,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      650: {
        costPerLead: 50,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      250: {
        costPerLead: 50,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      50: {
        costPerLead: 50,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 1,
      },
      750: {
        costPerLead: 50,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      350: {
        costPerLead: 50,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 9,
      },
      500: {
        costPerLead: 50,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      850: {
        costPerLead: 50,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      900: {
        costPerLead: 50,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 24,
      },
      550: {
        costPerLead: 50,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      300: {
        costPerLead: 50,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      950: {
        costPerLead: 50,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      600: {
        costPerLead: 50,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      150: {
        costPerLead: 50,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 4,
      },
      800: {
        costPerLead: 50,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 21,
      },
      700: {
        costPerLead: 50,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      1000: {
        costPerLead: 50,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      200: {
        costPerLead: 50,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
    },
  },
  78: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 27,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      100: {
        costPerLead: 27,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      450: {
        costPerLead: 27,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      650: {
        costPerLead: 27,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      250: {
        costPerLead: 27,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      50: {
        costPerLead: 27,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 27,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 37,
      },
      350: {
        costPerLead: 27,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      500: {
        costPerLead: 27,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      850: {
        costPerLead: 27,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 42,
      },
      900: {
        costPerLead: 27,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 44,
      },
      550: {
        costPerLead: 27,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      300: {
        costPerLead: 27,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      950: {
        costPerLead: 27,
        lowLeadsEstimate: 28,
        highLeadsEstimate: 47,
      },
      600: {
        costPerLead: 27,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 29,
      },
      150: {
        costPerLead: 27,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      800: {
        costPerLead: 27,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 39,
      },
      700: {
        costPerLead: 27,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 34,
      },
      1000: {
        costPerLead: 27,
        lowLeadsEstimate: 29,
        highLeadsEstimate: 49,
      },
      200: {
        costPerLead: 27,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
    },
  },
  8: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 10,
        lowLeadsEstimate: 33,
        highLeadsEstimate: 55,
      },
      100: {
        costPerLead: 10,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      450: {
        costPerLead: 10,
        lowLeadsEstimate: 37,
        highLeadsEstimate: 62,
      },
      650: {
        costPerLead: 10,
        lowLeadsEstimate: 53,
        highLeadsEstimate: 89,
      },
      250: {
        costPerLead: 10,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 34,
      },
      50: {
        costPerLead: 10,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      750: {
        costPerLead: 10,
        lowLeadsEstimate: 62,
        highLeadsEstimate: 103,
      },
      350: {
        costPerLead: 10,
        lowLeadsEstimate: 29,
        highLeadsEstimate: 48,
      },
      500: {
        costPerLead: 10,
        lowLeadsEstimate: 41,
        highLeadsEstimate: 69,
      },
      850: {
        costPerLead: 10,
        lowLeadsEstimate: 70,
        highLeadsEstimate: 116,
      },
      900: {
        costPerLead: 10,
        lowLeadsEstimate: 74,
        highLeadsEstimate: 123,
      },
      550: {
        costPerLead: 10,
        lowLeadsEstimate: 45,
        highLeadsEstimate: 75,
      },
      300: {
        costPerLead: 10,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 41,
      },
      950: {
        costPerLead: 10,
        lowLeadsEstimate: 78,
        highLeadsEstimate: 130,
      },
      600: {
        costPerLead: 10,
        lowLeadsEstimate: 49,
        highLeadsEstimate: 82,
      },
      150: {
        costPerLead: 10,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 21,
      },
      800: {
        costPerLead: 10,
        lowLeadsEstimate: 66,
        highLeadsEstimate: 110,
      },
      700: {
        costPerLead: 10,
        lowLeadsEstimate: 58,
        highLeadsEstimate: 96,
      },
      1000: {
        costPerLead: 10,
        lowLeadsEstimate: 82,
        highLeadsEstimate: 137,
      },
      200: {
        costPerLead: 10,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
    },
  },
  80: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 29,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      100: {
        costPerLead: 29,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      450: {
        costPerLead: 29,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      650: {
        costPerLead: 29,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 30,
      },
      250: {
        costPerLead: 29,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 11,
      },
      50: {
        costPerLead: 29,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 29,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 34,
      },
      350: {
        costPerLead: 29,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      500: {
        costPerLead: 29,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      850: {
        costPerLead: 29,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 39,
      },
      900: {
        costPerLead: 29,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 41,
      },
      550: {
        costPerLead: 29,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      300: {
        costPerLead: 29,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      950: {
        costPerLead: 29,
        lowLeadsEstimate: 26,
        highLeadsEstimate: 43,
      },
      600: {
        costPerLead: 29,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      150: {
        costPerLead: 29,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      800: {
        costPerLead: 29,
        lowLeadsEstimate: 22,
        highLeadsEstimate: 36,
      },
      700: {
        costPerLead: 29,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 32,
      },
      1000: {
        costPerLead: 29,
        lowLeadsEstimate: 27,
        highLeadsEstimate: 45,
      },
      200: {
        costPerLead: 29,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
    },
  },
  82: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 32,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      100: {
        costPerLead: 32,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      450: {
        costPerLead: 32,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      650: {
        costPerLead: 32,
        lowLeadsEstimate: 16,
        highLeadsEstimate: 27,
      },
      250: {
        costPerLead: 32,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      50: {
        costPerLead: 32,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      750: {
        costPerLead: 32,
        lowLeadsEstimate: 19,
        highLeadsEstimate: 31,
      },
      350: {
        costPerLead: 32,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      500: {
        costPerLead: 32,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 21,
      },
      850: {
        costPerLead: 32,
        lowLeadsEstimate: 21,
        highLeadsEstimate: 36,
      },
      900: {
        costPerLead: 32,
        lowLeadsEstimate: 23,
        highLeadsEstimate: 38,
      },
      550: {
        costPerLead: 32,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      300: {
        costPerLead: 32,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      950: {
        costPerLead: 32,
        lowLeadsEstimate: 24,
        highLeadsEstimate: 40,
      },
      600: {
        costPerLead: 32,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 25,
      },
      150: {
        costPerLead: 32,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      800: {
        costPerLead: 32,
        lowLeadsEstimate: 20,
        highLeadsEstimate: 33,
      },
      700: {
        costPerLead: 32,
        lowLeadsEstimate: 18,
        highLeadsEstimate: 29,
      },
      1000: {
        costPerLead: 32,
        lowLeadsEstimate: 25,
        highLeadsEstimate: 42,
      },
      200: {
        costPerLead: 32,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
    },
  },
  84: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 55,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      100: {
        costPerLead: 55,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      450: {
        costPerLead: 55,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 11,
      },
      650: {
        costPerLead: 55,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 16,
      },
      250: {
        costPerLead: 55,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      50: {
        costPerLead: 55,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 1,
      },
      750: {
        costPerLead: 55,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      350: {
        costPerLead: 55,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      500: {
        costPerLead: 55,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      850: {
        costPerLead: 55,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 21,
      },
      900: {
        costPerLead: 55,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      550: {
        costPerLead: 55,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      300: {
        costPerLead: 55,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      950: {
        costPerLead: 55,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      600: {
        costPerLead: 55,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      150: {
        costPerLead: 55,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 4,
      },
      800: {
        costPerLead: 55,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 19,
      },
      700: {
        costPerLead: 55,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      1000: {
        costPerLead: 55,
        lowLeadsEstimate: 15,
        highLeadsEstimate: 24,
      },
      200: {
        costPerLead: 55,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
    },
  },
  86: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 56,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      100: {
        costPerLead: 56,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      450: {
        costPerLead: 56,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 11,
      },
      650: {
        costPerLead: 56,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 16,
      },
      250: {
        costPerLead: 56,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      50: {
        costPerLead: 56,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 1,
      },
      750: {
        costPerLead: 56,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      350: {
        costPerLead: 56,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      500: {
        costPerLead: 56,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      850: {
        costPerLead: 56,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      900: {
        costPerLead: 56,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      550: {
        costPerLead: 56,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      300: {
        costPerLead: 56,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      950: {
        costPerLead: 56,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      600: {
        costPerLead: 56,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 14,
      },
      150: {
        costPerLead: 56,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 4,
      },
      800: {
        costPerLead: 56,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 19,
      },
      700: {
        costPerLead: 56,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      1000: {
        costPerLead: 56,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 24,
      },
      200: {
        costPerLead: 56,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
    },
  },
  88: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 77,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      100: {
        costPerLead: 77,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      450: {
        costPerLead: 77,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      650: {
        costPerLead: 77,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 11,
      },
      250: {
        costPerLead: 77,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      50: {
        costPerLead: 77,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 1,
      },
      750: {
        costPerLead: 77,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      350: {
        costPerLead: 77,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      500: {
        costPerLead: 77,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
      850: {
        costPerLead: 77,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      900: {
        costPerLead: 77,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 16,
      },
      550: {
        costPerLead: 77,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      300: {
        costPerLead: 77,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      950: {
        costPerLead: 77,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      600: {
        costPerLead: 77,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      150: {
        costPerLead: 77,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      800: {
        costPerLead: 77,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      700: {
        costPerLead: 77,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      1000: {
        costPerLead: 77,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      200: {
        costPerLead: 77,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
    },
  },
  90: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 58,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 9,
      },
      100: {
        costPerLead: 58,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      450: {
        costPerLead: 58,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      650: {
        costPerLead: 58,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      250: {
        costPerLead: 58,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 6,
      },
      50: {
        costPerLead: 58,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 1,
      },
      750: {
        costPerLead: 58,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      350: {
        costPerLead: 58,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      500: {
        costPerLead: 58,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      850: {
        costPerLead: 58,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      900: {
        costPerLead: 58,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 21,
      },
      550: {
        costPerLead: 58,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      300: {
        costPerLead: 58,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      950: {
        costPerLead: 58,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      600: {
        costPerLead: 58,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      150: {
        costPerLead: 58,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      800: {
        costPerLead: 58,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      700: {
        costPerLead: 58,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      1000: {
        costPerLead: 58,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      200: {
        costPerLead: 58,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
    },
  },
  92: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 61,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
      100: {
        costPerLead: 61,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      450: {
        costPerLead: 61,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      650: {
        costPerLead: 61,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 14,
      },
      250: {
        costPerLead: 61,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      50: {
        costPerLead: 61,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 1,
      },
      750: {
        costPerLead: 61,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      350: {
        costPerLead: 61,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      500: {
        costPerLead: 61,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 11,
      },
      850: {
        costPerLead: 61,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      900: {
        costPerLead: 61,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      550: {
        costPerLead: 61,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      300: {
        costPerLead: 61,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      950: {
        costPerLead: 61,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 21,
      },
      600: {
        costPerLead: 61,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      150: {
        costPerLead: 61,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      800: {
        costPerLead: 61,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      700: {
        costPerLead: 61,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      1000: {
        costPerLead: 61,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      200: {
        costPerLead: 61,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
    },
  },
  94: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 57,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 9,
      },
      100: {
        costPerLead: 57,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      450: {
        costPerLead: 57,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 11,
      },
      650: {
        costPerLead: 57,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      250: {
        costPerLead: 57,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      50: {
        costPerLead: 57,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 1,
      },
      750: {
        costPerLead: 57,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      350: {
        costPerLead: 57,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      500: {
        costPerLead: 57,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      850: {
        costPerLead: 57,
        lowLeadsEstimate: 12,
        highLeadsEstimate: 20,
      },
      900: {
        costPerLead: 57,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 21,
      },
      550: {
        costPerLead: 57,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      300: {
        costPerLead: 57,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      950: {
        costPerLead: 57,
        lowLeadsEstimate: 13,
        highLeadsEstimate: 22,
      },
      600: {
        costPerLead: 57,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 14,
      },
      150: {
        costPerLead: 57,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 4,
      },
      800: {
        costPerLead: 57,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 19,
      },
      700: {
        costPerLead: 57,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      1000: {
        costPerLead: 57,
        lowLeadsEstimate: 14,
        highLeadsEstimate: 23,
      },
      200: {
        costPerLead: 57,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
    },
  },
  96: {
    expectedLeadsByBudgetMap: {
      400: {
        costPerLead: 75,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 7,
      },
      100: {
        costPerLead: 75,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 2,
      },
      450: {
        costPerLead: 75,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 8,
      },
      650: {
        costPerLead: 75,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      250: {
        costPerLead: 75,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 4,
      },
      50: {
        costPerLead: 75,
        lowLeadsEstimate: 1,
        highLeadsEstimate: 1,
      },
      750: {
        costPerLead: 75,
        lowLeadsEstimate: 8,
        highLeadsEstimate: 13,
      },
      350: {
        costPerLead: 75,
        lowLeadsEstimate: 4,
        highLeadsEstimate: 6,
      },
      500: {
        costPerLead: 75,
        lowLeadsEstimate: 5,
        highLeadsEstimate: 9,
      },
      850: {
        costPerLead: 75,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 15,
      },
      900: {
        costPerLead: 75,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 16,
      },
      550: {
        costPerLead: 75,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 10,
      },
      300: {
        costPerLead: 75,
        lowLeadsEstimate: 3,
        highLeadsEstimate: 5,
      },
      950: {
        costPerLead: 75,
        lowLeadsEstimate: 10,
        highLeadsEstimate: 17,
      },
      600: {
        costPerLead: 75,
        lowLeadsEstimate: 6,
        highLeadsEstimate: 11,
      },
      150: {
        costPerLead: 75,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 3,
      },
      800: {
        costPerLead: 75,
        lowLeadsEstimate: 9,
        highLeadsEstimate: 14,
      },
      700: {
        costPerLead: 75,
        lowLeadsEstimate: 7,
        highLeadsEstimate: 12,
      },
      1000: {
        costPerLead: 75,
        lowLeadsEstimate: 11,
        highLeadsEstimate: 18,
      },
      200: {
        costPerLead: 75,
        lowLeadsEstimate: 2,
        highLeadsEstimate: 4,
      },
    },
  },
};

export default expectedLeadsByCategoryGroupIdMap;



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/LeadCalculator/data/categories-estimated-lead-count.js